import { FiAtSign, FiMapPin, FiLogOut } from 'react-icons/fi';
import DashboardLayout from '../../components/layout/DashboardLayout';
import SectionCard from '../../components/ui/SectionCard';
import { useAuth } from '../../context/AuthContext';
import { ROLE_LABELS } from '../../models/roles';
import { getInitials } from '../../utils/format';

/** Perfil compartido entre los tres roles: muestra datos de cuenta + logout. */
export default function ProfileView() {
  const { user, logout } = useAuth();

  return (
    <DashboardLayout title="Perfil" subtitle="Tu cuenta">
      <SectionCard>
        <div className="profile-card">
          <span className="profile-card__avatar">{getInitials(user.name)}</span>
          <span className="profile-card__name">{user.name}</span>
          <span className="pill">{ROLE_LABELS[user.role]}</span>
        </div>
        <div className="info-row">
          <span><FiAtSign /> Correo</span>
          <span>{user.email}</span>
        </div>
        {user.region && (
          <div className="info-row">
            <span><FiMapPin /> Zona</span>
            <span>{user.region}</span>
          </div>
        )}
      </SectionCard>


      <SectionCard title="Aplicación">
        <div className="info-row">
          <span>Versión</span>
          <span>0.1.0</span>
        </div>
        <div className="info-row">
          <span>Datos</span>
          <span>Ejemplo / demo</span>
        </div>
      </SectionCard>

      <button type="button" className="btn btn-outline btn-block" onClick={logout}>
        <FiLogOut /> Cerrar sesión
      </button>
    </DashboardLayout>
  );
}
